import type { SmarcticoPushTokenPayload } from '../types';

export function handleSmarcticoPushToken(
  payload: SmarcticoPushTokenPayload,
): void {
  window.__nativePushToken = payload;

  const sdk = window._smartico;

  if (
    sdk &&
    typeof sdk.checkSuccessfullyIdentify === 'function' &&
    sdk.checkSuccessfullyIdentify() &&
    typeof sdk.registerNativePushToken === 'function'
  ) {
    try {
      sdk.registerNativePushToken(
        payload.token,
        payload.platform,
        payload.packageId,
      );
    } catch {
      // ack negativo sera disparado pelo init.ts se a chamada via
      // store falhar; aqui silenciamos pra nao poluir o log
    }
  }
}
